import { useNotifications } from '../hooks/useNotifications';

const NotificationInitializer: React.FC = () => {
  // Initialize notifications when this component mounts
  useNotifications();
  
  // This component doesn't render anything, it just initializes notifications
  return null;
};

export default NotificationInitializer;
